[
  {
    "id": "chapter:9a",
    "q": "If a truck or bus needs to make a right turn and you are also turning right:",
    "answer": {
      "text": "Wait until the truck or bus turns before turning right",
      "section": 9,
      "topic": "Interacting with Commercial Vehicles",
      "page": 87
    },
    "otherChoices": [
      "Quickly turn right before the truck or bus does",
      "Squeeze between the truck or bus and the curb"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:9b",
    "q": "If a pedestrian is crossing in the middle of the street, not at a crosswalk (also known as jaywalking), even if it is illegal, you:",
    "answer": {
      "text": "Must stop for them",
      "section": 9,
      "topic": "Pedestrians",
      "page": 80
    },
    "otherChoices": ["Do not have to stop for them", "Should honk your horn at them"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:9c",
    "q": "When you hear a siren or see a vehicle approaching with flashing lights:",
    "answer": {
      "text": "Pull over to the curb or edge of the road and stop to allow the emergency vehicle to pass",
      "section": 9,
      "topic": "Emergency Vehicles",
      "page": 85
    },
    "otherChoices": [
      "Maintain speed and stay in your lane until the vehicle has passed",
      "Move into the right lane and drive slowly until the vehicle has passed"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:9d",
    "q": "Motorcycle operators have the right to:",
    "answer": {
      "text": "Use a complete traffic lane",
      "section": 9,
      "topic": "Motorcycles, Scooters and Mopeds",
      "page": 83
    },
    "otherChoices": ["Share a traffic lane with a vehicle", "Use the shoulder of a roadway"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "sample:9",
    "q": "When you meet a large vehicle coming from the opposite direction you should:",
    "answer": {
      "text": "Keep as far as possible to the right side",
      "section": 9,
      "topic": "Interacting with Commercial Vehicles",
      "page": 87
    },
    "otherChoices": ["Remain in the center of the lane", "Keep as far as possible to the left side"],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:9:derived:a",
    "q": "If cutting off a large vehicle would let you reach an exit or turn, the few seconds saved:",
    "answer": {
      "text": "Are not worth a life",
      "section": 9,
      "topic": "Interacting with Commercial Vehicles",
      "page": 87
    },
    "otherChoices": ["Justify the maneuver if you signal first", "Outweigh the risk on a clear highway"],
    "generated": {
      "parent": "sample:9",
      "type": "paired",
      "rationale": "Paired counterpart of sample:9 sourced from the same Interacting with Commercial Vehicles bulleted list on page 87: 'Do not cut off a large vehicle in traffic or on the highway to reach an exit or turn or to beat a truck into a single-lane construction zone. The few seconds that might be saved are not worth a life.' Question stem and answer split the rationale sentence at the natural pivot, mirroring how sample:9 splits its own handbook sentence. Distractors are alternative completions that sound permissive in the same way sample:9's distractors offer plausible alternative directions. The variant does not duplicate chapter:9a, which covers a truck or bus making its own right turn."
    },
    "batch": "review-20260502b",
    "version": 2,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "sample:10",
    "q": "Why is it important to stop at stop lines?",
    "answer": {
      "text": "To give larger vehicles more turning space",
      "section": 9,
      "topic": "Interacting with Commercial Vehicles",
      "page": 87
    },
    "otherChoices": ["So the traffic light changes faster", "To give pedestrians more room to walk"],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:10:derived:a",
    "q": "When in doubt about the speed of an oncoming truck or bus:",
    "answer": {
      "text": "Do not turn left in its path",
      "section": 9,
      "topic": "Interacting with Commercial Vehicles",
      "page": 87
    },
    "otherChoices": [
      "Turn left quickly before it reaches the intersection",
      "Turn left because trucks and buses can stop in less distance than a car"
    ],
    "generated": {
      "parent": "sample:10",
      "type": "paired",
      "rationale": "Paired counterpart of sample:10 sourced from the same Interacting with Commercial Vehicles bulleted list on page 87: 'When in doubt about the speed of an oncoming truck or bus, do not turn left in its path. The truck or bus may be going faster than you think and it takes longer for them to stop than a car.' Question stem and answer split the directive sentence at the natural pivot, mirroring how the verified pairs split their handbook sentences. Distractors are alternative completions that invert the same bullet's teaching that trucks take longer to stop than cars."
    },
    "batch": "review-20260502b",
    "version": 2,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "authored:s9-slow-moving-vehicle-emblem",
    "q": "A fluorescent or reflective orange and red triangle on the rear of a vehicle means the vehicle:",
    "answer": {
      "text": "Is traveling less than 25 mph",
      "section": 9,
      "topic": "Slow Moving Vehicles",
      "page": 88
    },
    "otherChoices": ["Is traveling less than 10 mph", "Makes frequent stops"],
    "generated": null,
    "batch": "review-20260604",
    "version": 2,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s9-transit-bus-stop",
    "q": "When a transit bus stops to drop off or pick up passengers, you:",
    "answer": {
      "text": "Do not have to stop, unless you are behind them",
      "section": 9,
      "topic": "Transit Buses",
      "page": 87
    },
    "otherChoices": [
      "Must stop, the same as you would for a school bus",
      "Must stop only if you are approaching from the opposite direction"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s9-right-turn-bicyclist",
    "q": "If you are about to make a right turn and a bicyclist is ahead, you should:",
    "answer": {
      "text": "Slow down and let the cyclist clear the intersection before making your turn",
      "section": 9,
      "topic": "Bicycles",
      "page": 81
    },
    "otherChoices": ["Pass the bicyclist immediately before the turn", "Sound your horn to alert your presence"],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s9-pedestrian-no-sidewalk",
    "q": "As a pedestrian, if there is no sidewalk, you should walk:",
    "answer": {
      "text": "On the left side of the street facing the oncoming traffic",
      "section": 9,
      "topic": "Pedestrians",
      "page": 79
    },
    "otherChoices": ["On the right side of the roadway", "Single file near the right curb or road edge"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s9-move-over-law",
    "q": "State law requires drivers approaching a stationary emergency vehicle displaying flashing lights, traveling in the same direction, to:",
    "answer": {
      "text": "Vacate the lane closest if safe and possible to do so, or slow to a speed safe for road, weather, and traffic conditions",
      "section": 9,
      "topic": "Move-Over Laws",
      "page": 85
    },
    "otherChoices": [
      "Pull over to the curb or edge of the road and stop",
      "Stay at least 500 feet away from the emergency vehicle"
    ],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s9-motorcycle-following-distance",
    "q": "When following a motorcyclist, allow for a following distance of:",
    "answer": {
      "text": "3 to 4 seconds, or more in wet conditions",
      "section": 9,
      "topic": "Motorcycles, Scooters and Mopeds",
      "page": 84
    },
    "otherChoices": [
      "Two seconds with an additional second for any unusual weather or traffic conditions",
      "The same distance as for another car, since motorcycles have the same braking capabilities"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s9-no-zone",
    "q": "The No-Zone is:",
    "answer": {
      "text": "The area around large trucks or buses where vehicles disappear from the commercial driver's view into blind spots",
      "section": 9,
      "topic": "Interacting with Commercial Vehicles, The No-Zone",
      "page": 86
    },
    "otherChoices": [
      "A space set aside for pedestrians boarding, entering, and waiting for trolleys and light rail vehicles",
      "A special escape ramp area on long downgrades for large vehicles that cannot stop"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s9-police-stop",
    "q": "If you are pulled over by law enforcement, you should:",
    "answer": {
      "text": "Keep your hands on the steering wheel and limit movements",
      "section": 9,
      "topic": "Police/Traffic Stops",
      "page": 85
    },
    "otherChoices": [
      "Get out of the vehicle and walk back to meet the officer",
      "Leave your engine running and your radio playing"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s9-motorcycle-dim-high-beams",
    "q": "When approaching a motorcycle, scooter or moped, you should:",
    "answer": {
      "text": "Always dim your high beams",
      "section": 9,
      "topic": "Motorcycles, Scooters and Mopeds",
      "page": 84
    },
    "otherChoices": [
      "Wait until you are within about a one-block distance to dim your high beams",
      "Flash your headlights once quickly"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s9-truck-mirror-face",
    "q": "When driving alongside a large truck, if you cannot see the driver's face in the side view mirror:",
    "answer": {
      "text": "The driver cannot see you",
      "section": 9,
      "topic": "Interacting with Commercial Vehicles, The No-Zone",
      "page": 86
    },
    "otherChoices": [
      "You are safely outside the driver's blind spot",
      "You have moved past the truck's side No-Zone, which ends just behind the cab"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 3,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s9-farm-machinery-right-turn",
    "q": "Farm machinery usually does not have turn signals, so when the machinery ahead of you pulls wide to the left, be prepared for:",
    "answer": {
      "text": "A right turn made from that wide left position",
      "section": 9,
      "topic": "Farm machinery",
      "page": 88
    },
    "otherChoices": [
      "A left turn into a field or driveway",
      "A chance to pass on the right, since the operator has moved over"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s9-bicyclists-two-abreast",
    "q": "As a bicyclist, you are allowed to:",
    "answer": {
      "text": "Ride two abreast or two wide in a lane",
      "section": 9,
      "topic": "Bicyclists",
      "page": 81
    },
    "otherChoices": [
      "Ride on the left side of the street facing the oncoming traffic",
      "Ride without a headlight at dusk"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s9-safety-zone-passing",
    "q": "You may pass a safety zone, where pedestrians board trolleys and light rail vehicles:",
    "answer": {
      "text": "As soon as it is safe to do so and at no faster than 10 mph",
      "section": 9,
      "topic": "Public Transportation, Transit Buses",
      "page": 87
    },
    "otherChoices": [
      "Only after stopping behind the nearest door and waiting for people to reach a safe place",
      "At no faster than 25 mph"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s9-emergency-vehicle-garage",
    "q": "If an emergency vehicle with its emergency lights flashing is leaving or returning to its garage, you must:",
    "answer": {
      "text": "Stop until the emergency vehicle is safely out of your path",
      "section": 9,
      "topic": "Emergency Vehicles",
      "page": 85
    },
    "otherChoices": [
      "Proceed normally, because it is not responding to an emergency call",
      "Follow the vehicle, staying at least 500 feet to the rear"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s9-horseback-single-file",
    "q": "Horseback riders on the roadway must:",
    "answer": {
      "text": "Ride single file near the right curb or road edge, or on a usable right shoulder, lane or path",
      "section": 9,
      "topic": "Horseback riders",
      "page": 88
    },
    "otherChoices": ["Ride on the left side of the street facing the oncoming traffic", "Ride two abreast in a lane"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s9-motorcycle-left-turn-crashes",
    "q": "Nearly 40 percent of motorcycle crashes involving another motor vehicle were caused by:",
    "answer": {
      "text": "The other vehicle turning left in front of the motorcyclist",
      "section": 9,
      "topic": "Motorcycles, Scooters and Mopeds",
      "page": 83
    },
    "otherChoices": [
      "The other vehicle turning right in front of the motorcyclist",
      "Drivers passing motorcycles in the same lane"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s9-sharrows",
    "q": "Sharrows, pavement markings showing a bicycle with two chevrons pointing above it:",
    "answer": {
      "text": "Recommend where in a lane a bicyclist should ride to flow easiest with other traffic",
      "section": 9,
      "topic": "Bicyclists",
      "page": 82
    },
    "otherChoices": [
      "Designate a part of the roadway reserved for bicycle traffic",
      "Allow drivers of parked vehicles to open their doors without checking for bicyclists"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  }
]
